import React from 'react';
import { Button } from './Button';
import { Link } from './Router';
import { Zap } from 'lucide-react';

export const BannerCTA: React.FC = () => {
  return (
    <section className="py-20 relative overflow-hidden">
      {/* Aggressive Gradient Background without Pulse */}
      <div className="absolute inset-0 bg-gradient-to-r from-brand-orange via-red-500 to-brand-orange bg-[length:200%_200%]"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center flex flex-col items-center">
        <h2 className="text-4xl md:text-6xl font-black text-white uppercase tracking-tighter mb-8 drop-shadow-lg">
          Genug gewartet.
        </h2>
        <p className="text-xl md:text-2xl text-white font-bold mb-10 max-w-3xl mx-auto opacity-90">
          Deine Konkurrenz schläft nicht. Hol dir jetzt den unfairen Vorteil und dominiere deinen lokalen Markt.
        </p>
        
        <div className="flex justify-center">
            <Link to="/kontakt">
              <Button variant="white" className="text-xl px-12 py-6 shadow-2xl hover:scale-105 transform transition-transform">
                 <Zap className="mr-2 fill-brand-orange text-brand-orange" />
                 Jetzt Dominanz sichern
              </Button>
            </Link>
        </div>
      </div>
    </section>
  );
};